// extracted by mini-css-extract-plugin
export default {"wrap":"oH-z","fullWidth":"pH-z","hideOnDesktop":"qH-z","content":"rH-z","hasOpenedNav":"sH-z","crumbsList":"tH-z","dropdownsWrap":"uH-z"};